import { useTranslation, Trans } from 'react-i18next'
import { InfoBlueIcon } from '@/components/icons'
import Icon from '@/components/icon'
import {
  ContentWrapper,
  AutoPaymentsWrapper,
  AutomaticPaymentsTitle,
  PaymentsErrorWrapper,
  PaymentsErrorInnerWrapper,
  PaymentsErrorTitle,
  PaymentsErrorText
} from './elements'
import { PaymentData } from '../types'

type PaymentStatusProps = {
  paymentData: PaymentData
}

const PaymentStatus: React.FC<PaymentStatusProps> = ({ paymentData }) => {
  const { t } = useTranslation()

  const getPaymentBanner = () => {
    const {
      payment_status: paymentStatus,
      error_side: errorSide,
      error_message: errorMessage
    } = paymentData

    const isTenantError = errorSide === 'tenant'

    const errorText = isTenantError ? (
      <Trans
        t={t}
        key="r.pad_payments.tenant_error.text"
        i18nKey="t.pad_payments.tenant_error.text"
        values={{ errorMessage }}
      >
        We couldn't process your payment because {{ errorMessage }}. Please verify that you have the
        available funds and ensure your banking information is entered correctly, then try again.
      </Trans>
    ) : (
      <Trans
        t={t}
        key="r.pad_payments.landlord_error.text"
        i18nKey="t.pad_payments.landlord_error.text"
        values={{ errorMessage }}
      >
        The payment amount was received from the tenant but couldn't be processed because
        {{ errorMessage }}. The payment amount has been refunded back to the tenant. Please make
        sure your bank account information provided is correct before the next recurring payment. If
        this issues persists, please contact us at support@liv.rent to resolve this issue.
      </Trans>
    )

    switch (paymentStatus) {
      case 'upcoming':
        return (
          <AutoPaymentsWrapper>
            <InfoBlueIcon />
            <AutomaticPaymentsTitle>
              {t(
                'r.listing.view.automatic_rent_payments.text',
                'Automatic rental payments have been set up for this listing.'
              )}
            </AutomaticPaymentsTitle>
          </AutoPaymentsWrapper>
        )
      case 'fail':
        return (
          <PaymentsErrorWrapper>
            <Icon id="warning_alert" color="red" width="42px" height="25px" />
            <PaymentsErrorInnerWrapper>
              <PaymentsErrorTitle>
                {t('r.listing.view.payments_error_tenant.title', 'Payment Failed')}
              </PaymentsErrorTitle>
              <PaymentsErrorText>{errorText}</PaymentsErrorText>
            </PaymentsErrorInnerWrapper>
          </PaymentsErrorWrapper>
        )

      default:
        return null
    }
  }

  return <ContentWrapper bottom={0}>{getPaymentBanner()}</ContentWrapper>
}

export default PaymentStatus
